import { PagedSearch } from 'src/app/shared';

export interface ContactSearchDto extends PagedSearch {
  ProfileId: number;
  Contactee: string;
  SubjectKeyword: string;
  StartDate: Date;
  EndDate: Date;
  ContactTypes: string[];
  IncludeContactsFromEmailTool: boolean;
}

export function initializeContactSearchDto(): ContactSearchDto {
  return {
    TotalCount: 0,
    TotalPages: 0,
    PageNumber: 1,
    PageSize: 20,
  } as ContactSearchDto;
}
